import { PagedResponse } from '@elotech/components';
import axios, { AxiosPromise } from 'axios';
import { Protocolo } from 'common/type';
import { ProtocoloDTO } from 'common/type/ProtocoloDTO';
import { isNumber } from 'common/utils';

const resource = '/compras-api/api/protocolos';

export const findAll = (
  search: string = ''
): AxiosPromise<PagedResponse<Protocolo>> => {
  const filtro = isNumber(search) ? `?search=id.numero==${search}` : '';

  return axios.get(`${resource}${filtro}`);
};

export const findAllProcesso = (
  numero: string = '',
  ano: string = '',
  entidade?: string | number
): AxiosPromise<PagedResponse<ProtocoloDTO>> => {
  const filterEntidade = entidade ? `and entidade.id==${entidade}` : '';

  return axios.get(
    `${resource}/processos?search=id.numero==${numero} and id.ano==${ano}${filterEntidade}`
  );
};
